// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"26047fee","36":"c7f43677","222":"c79e93bd","231":"0e050185","318":"b7548c80","371":"72e2dcec","423":"fc8a7a2e","453":"3530170e","465":"bd09a530","569":"511d5ee3"}[chunkId] + ".chunk.js";
};